import React, { useState } from 'react';
import { Menu, X } from 'react-feather';
import './Navbar.css';

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar-overlay">
      <div className="navbar-card">
        <div className="navbar-left">
          <img src={process.env.PUBLIC_URL + '/rskpay.png'} alt="RSKPay" />
          <span>RSKPay</span>
        </div>
        <div className="navbar-menu-container">
          <ul className="navbar-menu">
            <li><a href="#home">Home</a></li>
            <li><a href="#about">About</a></li>
            <li><a href="#services">Services</a></li>
            <li><a href="#features">Features</a></li>
            <li><a href="#how-it-works">How It Works</a></li>
            <li><a href="#download">Download</a></li>
          </ul>
        </div>
        <button className="navbar-toggle" onClick={toggleMenu} aria-label="Toggle Menu">
          {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>
      
      {/* Mobile Menu */}
      <div className={`navbar-mobile-menu ${isMenuOpen ? 'active' : ''}`}>
        <ul>
          <li><a href="#home" onClick={closeMenu}>Home</a></li>
          <li><a href="#about" onClick={closeMenu}>About</a></li>
          <li><a href="#services" onClick={closeMenu}>Services</a></li>
          <li><a href="#features" onClick={closeMenu}>Features</a></li>
          <li><a href="#how-it-works" onClick={closeMenu}>How It Works</a></li>
          <li><a href="#download" onClick={closeMenu}>Download</a></li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
